// @flow
import store from '../../../redux/store' // TODO: Bad. Access to store
import * as campaignTableActions from '../campaignTable/reducers' // TODO: Bad. Access to foreign duck
import { open, close, update } from './reducers'
import postJson from '../../../services/postJson'

export function openForm(state: Object = {}) {
  store.dispatch(open(state))
}

export function closeForm() {
  store.dispatch(close())
}

export function openFormFromCampaign(campaignId: number, campaignName: string) {
  openForm({ campaignId, campaignName, currentName: campaignName })
}

export function inputNameForm(name: string) {
  updateForm({ currentName: name })
}

export function saveRenaming() {
  const { currentName, campaignId, putching } = store.getState().renameCampaignForm

  if (putching) return

  const url = `/api/v1/campaigns/${campaignId}`
  const data = {
    id: campaignId,
    campaign: {
      name: currentName
    }
  }

  setPatching()

  postJson(url, data)
    .done(() => {
      replaceNameById(campaignId, currentName)
      closeForm()
    })
    .fail((e) => {
      if (e) {
        setErrors(e.responseJSON)
      }
    })
    .always(() => {
      defusePatching()
    })
}

// ----------------------
// private functions
// ----------------------

function updateForm(state = {}) {
  store.dispatch(update(state))
}

function setErrors(errorMessages = []) {
  updateForm({ errors: true, errorMessages })
}

// blocks making requests to rename
function setPatching() {
  updateForm({ patching: true })
}

// allows making requests to rename
function defusePatching() {
  updateForm({ patching: false })
}

function replaceNameById(id, newName) {
  const { campaignList } = store.getState().campaignTable

  const newCampaignList = campaignList.map((campaign) => {
    if (campaign.id === id) {
      const campaignDup = { ...campaign }
      campaignDup.campaignName = newName
      return campaignDup
    }

    return campaign
  })

  store.dispatch(campaignTableActions.patch({ campaignList: newCampaignList }))
}

export function validateName() {
  const { currentName, campaignName } = store.getState().renameCampaignForm

  return currentName.length !== 0 && campaignName !== currentName
}
